import {Monitor} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const ComputerIcon = createLucideIcon(Monitor, 'ComputerIcon');
